<template>
  <div>
    <!-- 总 -->
    <div style="background-color: #f2f3f3; padding: 0% 10% 0px 10%">
      <!-- 三分 -->
      <div
        style="display: flex; justify-content: space-between; flex-wrap: wrap"
      >
        <!-- 三分之左 -->
        <div
          style="display: flex; flex-direction: column; justify-content: center"
        >
          <img
            src="https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/touminglogo.png"
            alt="图片加载失败"
            style="
              height: 60px;
              width: 320px;
              margin-top: 100px;
              margin-bottom: 20px;
            "
          />
          <div style="font-size: 18px; font-weight: bold">
            {{ $t("bottom.捷丰林合工业设备(上海)有限公司") }}
          </div>
          <div style="margin-bottom: 20px">
            {{ $t("bottom.江苏省太仓市陆渡镇江南路81号丰田叉车") }}
          </div>
          <div style="margin-bottom: 20px">
            {{ $t("bottom.统一社会信用代码:91310120324706632P") }}
          </div>
          <div>
            {{ $t("bottom.企业网站") }}
          </div>
        </div>
        <!-- 三分之左 -->

        <!-- 三分之中 -->
        <div
          style="display: flex; flex-direction: column; justify-content: center"
        >
          <div
            style="
              margin-bottom: 20px;
              font-size: 25px;
              font-weight: bold;
              text-align: center;
            "
          >
            {{ $t("bottom.社交媒体") }}
          </div>
          <!-- 三分之中之下 -->
          <div style="display: flex; justify-content: space-between">
            <div
              @click="openImage1"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                height: 70px;
                width: 70px;
                border: 1px solid black;
                border-radius: 50%;
                margin-right: 15px;
              "
            >
              <img
                src="https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/douyin.png"
                alt="图片加载失败"
              />
            </div>
            <div
              @click="openImage2"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                height: 70px;
                width: 70px;
                border: 1px solid black;
                border-radius: 50%;
                margin-right: 15px;
              "
            >
              <img
                src="https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/weixin.png"
                alt="图片加载失败"
              />
            </div>
            <div
              @click="openImage3"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                height: 70px;
                width: 70px;
                border: 1px solid black;
                border-radius: 50%;
                margin-right: 15px;
              "
            >
              <img
                src="https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/kuaishou.png"
                alt="图片加载失败"
              />
            </div>
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                height: 70px;
                width: 70px;
                border: 1px solid black;
                border-radius: 50%;
                margin-right: 15px;
              "
            >
              <img
                src="https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/Youtube.png"
                alt="图片加载失败"
              />
            </div>
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                height: 70px;
                width: 70px;
                border: 1px solid black;
                border-radius: 50%;
                margin-right: 15px;
              "
            >
              <img
                src="https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/facebook.png"
                alt="图片加载失败"
              />
            </div>
          </div>
          <!-- 三分之中之下 -->
        </div>
        <!-- 三分之中 -->

        <!-- 三分之右 -->
        <div
          style="display: flex; flex-direction: column; justify-content: center"
        >
          <div
            style="
              margin-bottom: 20px;
              font-size: 25px;
              font-weight: bold;
              text-align: center;
            "
          >
            {{ $t("bottom.相关社群") }}
          </div>
          <!-- 三分之右之下 -->
          <div style="display: flex; justify-content: space-between">
            <div
              class="circle-container"
              @click="openWebPage2('http://www.jfrental.com/')"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                height: 70px;
                width: 70px;
                border: 1px solid #ff5400;
                border-radius: 50%;
                margin-left: 15px;
                overflow: hidden; /* 确保超出div的内容被隐藏 */
              "
            >
              <svg
                class="svgLogoVozik"
                data-name="Vrstva 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 134.63 72.32"
              >
                width="40"
                <!-- 设置宽度为原始宽度的一半 -->
                height="40"
                <!-- 设置高度为原始高度的一半 -->
                >
                <g transform="scale(0.6) translate(35, 0)">
                  <!-- 使用scale变换来缩小SVG内容到一半大小 -->
                  <path
                    class="cls-1"
                    d="M105.23,76.42c.05-.31.11-.61.14-.94a9.08,9.08,0,0,0-1.26-6.23L102,29,94.66,19.8l5,45.94c-3.76-1.58-8.09-1.35-8.89-.66,3.93,2.1,7.73,5.81,7.68,9.21-.15,3.14-1.35,4.88-3,5.92-.3.19-.73.42-1.21.67-3.08-1-5.79-2.94-5.21-6.59-1.63.8-2.49.79-6.29.93a9.84,9.84,0,0,0,1.46,5.41c.92,1.7,3.22,2.87,5.78,3.49a19.53,19.53,0,0,0,5,.59,15.12,15.12,0,0,0,4.9-1.35l.48-.22a8,8,0,0,0,1.48-1h0A9,9,0,0,0,104,79.82c12.32.28,31.44-1.93,43.52-2.07l2.14-1.88C137.25,75.65,118.19,75.41,105.23,76.42Z"
                    fill="#ff5400"
                    stroke="#ff5400"
                    stroke-width="1"
                  ></path>
                  <path
                    class="cls-1"
                    d="M23.09,65.09c3.93,2.1,7.73,5.81,7.68,9.21-.15,3.14-1.35,4.88-3,5.92-.3.19-.73.42-1.22.67-3.08-1-5.79-2.94-5.21-6.59-1.63.8-2.49.79-6.29.93a9.86,9.86,0,0,0,1.46,5.41c.92,1.7,3.23,2.87,5.8,3.5a19.61,19.61,0,0,0,5,.58,15.14,15.14,0,0,0,4.86-1.33l.52-.24a7.91,7.91,0,0,0,1.48-1h0a9.09,9.09,0,0,0,3.54-6.69C39,64.14,24.61,63.77,23.09,65.09Z"
                    fill="#ff5400"
                    stroke="#ff5400"
                    stroke-width="1"
                  ></path>
                  <path
                    class="cls-1"
                    d="M87.39,65.9c2.39-1.8,8-2.91,8-2.91s-10-13.77-13.14-25.54a172.48,172.48,0,0,1-4.06-18.26c-.64,11.86-.52,16,2.41,25.13C83.27,52.6,90,59.67,90,59.67s-3.77-.49-8.27,3.56A40.37,40.37,0,0,0,77.2,67.9,74.31,74.31,0,0,0,59.66,52c-10.7-7-25.93-8.11-25.93-8.11L34,44s9.53.69,24.52,11.73A97.57,97.57,0,0,1,75.3,71.85l6.8,3.3S80.71,70.9,87.39,65.9Z"
                    fill="#ff5400"
                    stroke="#ff5400"
                    stroke-width="1"
                  ></path>
                  <path
                    class="cls-1"
                    d="M48.67,17.87c11.53-6.18,28.55.46,28.55.46s-17.33-9.72-31-4.26C25.56,22.34,23.88,44.46,23.88,44.46c-4.53,3.85-7.67,17.15-7.62,23.45,3.9-10.8,8.81-19.76,17.48-24C33.73,43.93,33.53,26,48.67,17.87Z"
                    fill="#ff5400"
                    stroke="#ff5400"
                    stroke-width="1"
                  ></path>
                  <path
                    class="cls-1"
                    d="M42.52,72.77c0,2,0,5.74-1.66,7.22,0,0,8.48-3.87,17.61-3.27,7.81.51,15.92,5.21,15.92,5.21S67.07,76,59.27,74.08C47.59,70.74,42.52,72.77,42.52,72.77Z"
                    fill="#ff5400"
                    stroke="#ff5400"
                    stroke-width="1"
                  ></path>
                </g>
              </svg>
            </div>

            <div
              class="circle-container"
              @click="openWebPage1('http://www.jfrental.com/')"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                height: 70px;
                width: 70px;
                border: 1px solid blue;
                border-radius: 50%;
                margin-left: 15px;
                overflow: hidden; /* 确保超出div的内容被隐藏 */
              "
            >
              <svg
                class="svgLogoVozik"
                data-name="Vrstva 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 134.63 72.32"
              >
                width="40"
                <!-- 设置宽度为原始宽度的一半 -->
                height="40"
                <!-- 设置高度为原始高度的一半 -->
                >
                <g transform="scale(0.6) translate(35, 0)">
                  <!-- 使用scale变换来缩小SVG内容到一半大小 -->
                  <path
                    class="cls-1"
                    d="M105.23,76.42c.05-.31.11-.61.14-.94a9.08,9.08,0,0,0-1.26-6.23L102,29,94.66,19.8l5,45.94c-3.76-1.58-8.09-1.35-8.89-.66,3.93,2.1,7.73,5.81,7.68,9.21-.15,3.14-1.35,4.88-3,5.92-.3.19-.73.42-1.21.67-3.08-1-5.79-2.94-5.21-6.59-1.63.8-2.49.79-6.29.93a9.84,9.84,0,0,0,1.46,5.41c.92,1.7,3.22,2.87,5.78,3.49a19.53,19.53,0,0,0,5,.59,15.12,15.12,0,0,0,4.9-1.35l.48-.22a8,8,0,0,0,1.48-1h0A9,9,0,0,0,104,79.82c12.32.28,31.44-1.93,43.52-2.07l2.14-1.88C137.25,75.65,118.19,75.41,105.23,76.42Z"
                    fill="blue"
                    stroke="blue"
                    stroke-width="1"
                  ></path>
                  <path
                    class="cls-1"
                    d="M23.09,65.09c3.93,2.1,7.73,5.81,7.68,9.21-.15,3.14-1.35,4.88-3,5.92-.3.19-.73.42-1.22.67-3.08-1-5.79-2.94-5.21-6.59-1.63.8-2.49.79-6.29.93a9.86,9.86,0,0,0,1.46,5.41c.92,1.7,3.23,2.87,5.8,3.5a19.61,19.61,0,0,0,5,.58,15.14,15.14,0,0,0,4.86-1.33l.52-.24a7.91,7.91,0,0,0,1.48-1h0a9.09,9.09,0,0,0,3.54-6.69C39,64.14,24.61,63.77,23.09,65.09Z"
                    fill="blue"
                    stroke="blue"
                    stroke-width="1"
                  ></path>
                  <path
                    class="cls-1"
                    d="M87.39,65.9c2.39-1.8,8-2.91,8-2.91s-10-13.77-13.14-25.54a172.48,172.48,0,0,1-4.06-18.26c-.64,11.86-.52,16,2.41,25.13C83.27,52.6,90,59.67,90,59.67s-3.77-.49-8.27,3.56A40.37,40.37,0,0,0,77.2,67.9,74.31,74.31,0,0,0,59.66,52c-10.7-7-25.93-8.11-25.93-8.11L34,44s9.53.69,24.52,11.73A97.57,97.57,0,0,1,75.3,71.85l6.8,3.3S80.71,70.9,87.39,65.9Z"
                    fill="blue"
                    stroke="blue"
                    stroke-width="1"
                  ></path>
                  <path
                    class="cls-1"
                    d="M48.67,17.87c11.53-6.18,28.55.46,28.55.46s-17.33-9.72-31-4.26C25.56,22.34,23.88,44.46,23.88,44.46c-4.53,3.85-7.67,17.15-7.62,23.45,3.9-10.8,8.81-19.76,17.48-24C33.73,43.93,33.53,26,48.67,17.87Z"
                    fill="blue"
                    stroke="blue"
                    stroke-width="1"
                  ></path>
                  <path
                    class="cls-1"
                    d="M42.52,72.77c0,2,0,5.74-1.66,7.22,0,0,8.48-3.87,17.61-3.27,7.81.51,15.92,5.21,15.92,5.21S67.07,76,59.27,74.08C47.59,70.74,42.52,72.77,42.52,72.77Z"
                    fill="blue"
                    stroke="blue"
                    stroke-width="1"
                  ></path>
                </g>
              </svg>
            </div>
          </div>
          <!-- 三分之右之下 -->
        </div>
        <!-- 三分之右 -->
      </div>
      <!-- 三分 -->
    </div>
    <!-- 总 -->
    <!-- 右下角 -->

    <div
      style="background-color: #f2f3f3; padding-right: 30px; text-align: right"
    >
      {{ $t("bottom.隐私政策|版权所有©捷丰林合工业设备(上海)有限公司") }}
    </div>
    <div @click="beian">
      <div
        style="
          background-color: #f2f3f3;
          padding-right: 30px;
          padding-bottom: 30px;
          text-align: right;
        "
      >
        沪ICP备2023010867号-1
      </div>
    </div>
    <!-- 右下角 -->
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  methods: {
    openWebPage1(url) {
      window.open(url, "_blank");
    },
    openWebPage2(url) {
      window.open(url, "_blank");
    },
    openImage1() {
      const imageUrl =
        "https://www.douyin.com/user/MS4wLjABAAAANmqWhaK8KvSGTZ_Wnexil0YSZk-yl4fDkLestDTMvsLi8cdXfUB5p0TvXn-e5aWp";
      window.open(imageUrl, "_blank");
    },
    openImage2() {
      const imageUrl =
        "https://upload-attch-1256082024.cos.ap-beijing.myqcloud.com/jf/jf_web_img/weixinopen.jpg";
      window.open(imageUrl, "_blank");
    },
    openImage3() {
      const imageUrl = "https://www.kuaishou.com/profile/3xpudupvb8napdw";
      window.open(imageUrl, "_blank");
    },
    beian() {
      const imageUrl = "https://beian.miit.gov.cn/";
      window.open(imageUrl, "_blank");
    },
  },
};
</script>

<style scoped>
.circle-container:hover {
  /* 更改背景颜色为蓝色 */
  background-color: blue;
}
.circle-container:hover .svgLogoVozik .cls-1 {
  /* 当鼠标悬停在 circle-container 上时，更改 SVG 路径的填充颜色为白色 */
  fill: white;
}
</style>
